import moment from 'moment';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant'

const defaultValue = {
    // [FORM_MAP.RANGE_TIME]: [moment().subtract(14, 'day').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD')],
    [FORM_MAP.RANGE_TIME]: [moment().subtract(1, 'day').format('YYYY-MM-DD'), moment().subtract(1, 'day').format('YYYY-MM-DD')],
    [FORM_MAP.RANGE_TIME_TYPE]: 'Day',
    [FORM_MAP.RANGE_TIME_DIFF]: false,
    [FORM_MAP.ZONE]: ['255'],
    [FORM_MAP.REGION]: {
        regions: [],
        markets: ['255'],
        region_type: 'market'
    },
    [FORM_MAP.SYSTEM]: ['255'],
    [FORM_MAP.LANGUAGE]: ['255'],
    [FORM_MAP.CHANNEL]: ['255'],
    [FORM_MAP.IS_INIT]: false
}

export default defaultValue;
